import { useEffect, useState } from "react";
import { GetAllBranches } from "../../../../services/CommonService";
import AddBranches from "./AddBranches";
import BranchesTable from "./BranchesTable";

const Branches=()=>{
    const [data, setData] = useState([]);
	useEffect(() => {
		getbranches();
	}, []);  

   const getbranches=async() =>{
    const branchesdata = await GetAllBranches({});
    setData(branchesdata.data.docs);
   }
    return(
        <>
      {data.length>0 && 
      <BranchesTable propdata={data}/>}

      {console.log("branchesdata",data)}
        </>
    )
}
export default Branches;